// shaker
(function() {
    function loop(callBack) {
        var collection = document.getElementsByClassName('product-form__submit');
        for (let i = 0; i < collection.length; i++) {
            callBack.call(this, collection[i]);
        }
    }
    loop(function(item){
        item.classList.add('btn-shaker');
    });
    setInterval(function(){
        loop(function(item){
            item.classList.add('active');
        });
        setTimeout(function() {
            loop(function(item){
                item.classList.remove('active');
            });
        }, 1000);
    }, 5000);
})();

// home video
(function () {
    //return;
    var target = document.querySelector('.image-with-text__media');
    if (!target) {
        return;
    }
    target.innerHTML = '';
    var host = 'https://cdn.shopify.com/';
    var video_list = [
        /*
        {
            poster: 's/files/1/0806/3690/3723/files/preview_images/34de0fb7be8b4aed986f576956b1c120.thumbnail.0000000000.jpg?v=1697179795',
            src: 'videos/c/o/v/34de0fb7be8b4aed986f576956b1c120.mp4'
        },
        {
            poster: 's/files/1/0806/3690/3723/files/preview_images/edbd93c8d44b4234bfe06cdde9a5161e.thumbnail.0000000000.jpg?v=1701762264',
            src: '//cdn.shopify.com/videos/c/o/v/edbd93c8d44b4234bfe06cdde9a5161e.mp4'
        },
        {
            poster: 's/files/1/0806/3690/3723/files/preview_images/bea13859bf9e4d0f81b759018203bf83.thumbnail.0000000000.jpg?v=1708404354',
            src: 'videos/c/o/v/bea13859bf9e4d0f81b759018203bf83.mp4'
        }
        */
        {
            poster: 's/files/1/0806/3690/3723/files/preview_images/201bdd5ce3f843c8aa38a5c8d5a60804.thumbnail.0000000000.jpg?v=1710985429',
            src: 'videos/c/o/v/201bdd5ce3f843c8aa38a5c8d5a60804.mp4'
        },
        {
            poster: 's/files/1/0806/3690/3723/files/preview_images/a419be90b8c84f80bfeb830ca52382e7.thumbnail.0000000000.jpg?v=1710985424',
            src: 'videos/c/o/v/a419be90b8c84f80bfeb830ca52382e7.mp4'
        }
    ];
    var video = video_list[Math.floor(Math.random() * video_list.length)];
    //video = video_list[2];

    var el = document.createElement('video');
    el.setAttribute("width", "323");
    el.setAttribute("height", "575");
    el.setAttribute("controls", "controls");
    el.setAttribute('controlslist', 'nodownload');
    el.setAttribute('poster', host + video.poster);
    el.setAttribute('src', host + video.src);
    target.appendChild(el);
})();